export const Login = {
  Title: 'Přihlášení',
  Username: 'Uživatelské jméno',
  Password: 'Heslo',
  Submit: 'Přihlásit',
};
